import { render } from "./BestOddsGuaranteedInfo.vue?vue&type=template&id=b4575924&scoped=true"
import script from "./BestOddsGuaranteedInfo.vue?vue&type=script&lang=js"
export * from "./BestOddsGuaranteedInfo.vue?vue&type=script&lang=js"

import "./BestOddsGuaranteedInfo.vue?vue&type=style&index=0&id=b4575924&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4575924"]])

export default __exports__